// Importing React and external libs
import React from 'react';
import PropTypes from 'prop-types';

// Importing component style
import './style.scss';

const { origin } = window && window.location;
const Error = ({ imgSrc, message }) => {
  return (
    <div className="error-wrapper">
      {imgSrc && (<img alt="img" src={imgSrc} />)}
      <div>{message}</div>
    </div>
  );
};

Error.propTypes = {
  imgSrc: PropTypes.string,
};

Error.defaultProps = {
  imgSrc: `${origin}/imgs/error.png`,
};

export default Error;
